import React from "react"

const CircleImage = props => {
  return (
    <div
      className={
        props.className ? `circle-image ${props.className}` : "circle-image"
      }
    ></div>
  )
}

export default CircleImage
